var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFfEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 48,
    viewBox: "0 0 78 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5134 26.4375L75.3735 3.69323L76.8845 2.75977C76.4618 1.17219 75.0066 0 73.2697 0H3.75965C2.02268 0 0.565095 1.17219 0.142394 2.75977L1.65586 3.69323L38.5134 26.4375ZM77.0239 9.42055V44.3069C77.0239 46.348 75.3428 48.0001 73.2682 48.0001H3.75815C1.68109 48.0001 0 46.348 0 44.3069V9.42055L37.5159 32.5635C37.8172 32.7569 38.1646 32.85 38.512 32.85C38.8593 32.85 39.2067 32.7569 39.508 32.5635L77.0239 9.42055Z",
    fill: "#E81111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfEnvelope);
export default __webpack_public_path__ + "static/media/FFEnvelope.72d62eef5026222bb97a1af800b82b47.svg";
export { ForwardRef as ReactComponent };